"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AbortIncompleteMultipartUpload = {
    type: "structure",
    required: [],
    members: {
        DaysAfterInitiation: {
            shape: {
                type: "integer"
            }
        }
    }
};
//# sourceMappingURL=_AbortIncompleteMultipartUpload.js.map